import { ManageAlerts } from './manage-alerts';
import { ManageAlertsProvider } from './manage-alerts.provider';

export const FeatureManageAlerts = () => {
   return (
      <ManageAlertsProvider>
         <ManageAlerts></ManageAlerts>
      </ManageAlertsProvider>
   );
};
